import OdFromDateEntry from 'lumen/utils/datamodels/overview-dashboard/od-from-date-entry';
import generateOdValueKey from 'lumen/utils/overview-dashboard/generate-od-value-key';

export default class OdApiResponse {
  // Array containing indivual values per stay date in the selected date range
  fromDates = [];
  // Object containing all relevant kpi values for the whole selected date range
  kpis = null;
  // Object containing extra meta data (mostly used for out of sync,...)
  meta = null;

  get isEmptyResponse() {
    return (
      !this.fromDates.length &&
      !Object.keys(this.kpis).length &&
      !Object.keys(this.meta).length
    );
  }

  constructor(fromDates, kpis, meta) {
    this.fromDates = fromDates.map(
      (fromDateData) => new OdFromDateEntry(fromDateData),
    );
    this.kpis = kpis;
    this.meta = meta;
  }

  static createEmptyResponse() {
    return new OdApiResponse([], {}, {});
  }

  static fromApiResponse(apiResponse) {
    return new OdApiResponse(
      apiResponse.from_dates,
      apiResponse.kpis,
      apiResponse.meta,
    );
  }

  getDataLastUpdateTimestamp(dataKey) {
    if (!this.kpis) {
      return null;
    }

    return this.kpis[`${dataKey}.timestamp`];
  }

  getDataValueFromKey(odSelections, baseKey, refDateId = null) {
    const odValueKey = generateOdValueKey(odSelections, baseKey, refDateId);

    return this.kpis?.[odValueKey] ?? null;
  }

  isDataOutOfSync(dataKey) {
    if (!this.kpis) {
      return null;
    }

    // Make sure that we can handle the null case (sometimes we don't want to show out of sync info - e.g. past dates)
    if (this.kpis[`${dataKey}.timestamp_ok`] === null) {
      return null;
    }

    // Reversing the value here as timestamp_ok of false means that the data is out of sync
    return !this.kpis[`${dataKey}.timestamp_ok`];
  }
}
